/**
 * Application version metadata.
 * Bump this manually when releasing user-facing changes so that users
 * (and you, when reviewing screenshots) can see which version they are on.
 *
 * Format: vMAJOR.MINOR · YYYY-MM-DD
 */
export const APP_VERSION = "1.8.0";
export const APP_BUILD_DATE = "2026-04-29";
